import { APIUrl, APIKey } from "../utils/config";

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${APIUrl()}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": APIKey(),
      ...(options?.headers || {}),
    },
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: "Unknown error" }));
    const error = new Error(err.detail || "Request failed") as Error & { status?: number };
    error.status = res.status;
    throw error;
  }

  return res.json();
}